/**
 * The position of the image in WizardPanel
 */
export enum WizardPanelImagePosition {
  TOP,
  TOP_OVERLAP,
}
